/* eslint-disable no-unused-vars */
import Image, { ImageProps } from 'next/image';
import { useMemo } from 'react';
import useSizeStyle from '@/hooks/useSizeStyle';
import { pixelToNumber } from '@/utils/style/ui';
import SliderBelt, { Props as SliderBeltProps } from './SliderBelt';

const DEFAULT_WIDTH = 160;
const DEFAULT_HEIGHT = 80;

export interface Props extends Omit<SliderBeltProps, 'items'> {
  items?: ImageProps['src'][];
}

export default function ImageSliderBelt({
  width: widthProps = DEFAULT_WIDTH,
  height: heightProps,
  items: itemsProps,
  ...props
}: Props) {
  // style
  const { sizeStyle: widthStyle } = useSizeStyle(widthProps);
  const { sizeStyle: heightStyle } = useSizeStyle(heightProps);

  // memo
  const height = useMemo(() => pixelToNumber(heightStyle), [heightStyle]);
  const width = useMemo(
    () => pixelToNumber(widthStyle) ?? DEFAULT_WIDTH,
    [widthStyle]
  );
  const items = useMemo(
    () =>
      itemsProps?.map((item, index) => (
        <Image alt="" width={width} height={height} src={item} key={index} />
      )),
    [width, height, itemsProps]
  );

  return <SliderBelt height={height} items={items} {...props} />;
}
